import styled from "styled-components";

import ModalBase, { styles as ModalStyles } from "/component/base/Modal";

export const Modal = styled(ModalBase)({
  [`& > ${ModalStyles.Body} > *`]: {
    width: "100%",
  },
});
